<template>
    <div class="info-wrap coupondetail">
        <CouponCard
            class="couponinfo"
            :validity="hasData ? orderInfo.expireTime.split(' ')[0].replace(/\//g,'-') : '' "
            :price="hasData ? orderInfo.couponAmount : '' "
            :tip="hasData ? orderInfo.couponExplain : '' "
            :couponname="hasData ? orderInfo.batchName : '' "
            :coupontype="hasData ? orderInfo.couponType : '' "
            :width=300
            :height=120
            padding="15px 12px" nameSize="18px"  priceSize="42px" status="1" />
        <div class="item">
            <label>发券期限</label>
            <span class="msg">{{hasData ? orderInfo.startTime.replace(/\//g,'-') : '' }} — {{hasData ? orderInfo.expireTime.replace(/\//g,'-') : ''}}</span>
        </div>
        <div class="item">
            <label>购券张数</label>
            <span class="msg">{{hasData ? orderInfo.totalNumber : ''}}张</span>
            <span v-if="hasData && orderInfo && !!orderInfo.giftNumber" class="msg_tip">（活动赠送{{orderInfo.giftNumber}}张，共计{{orderInfo.totalNumber+orderInfo.giftNumber}}张）</span>
        </div>
        <div class="item">
            <label>发券总金额</label>
            <span class="msg">{{hasData ? orderInfo.totalCouponAmount : ''}}元</span>
        </div>
        <div class="item">
            <label>结算方式</label>
            <span class="msg">{{hasData ? orderInfo.payTypeDesc : ''}}</span>
        </div>
            <div class="item">
            <label>制券服务费</label>
            <span class="msg">{{hasData ? orderInfo.serviceAmount : ''}}元</span>
            <div class="hintmsg">按使用量结算要收取的制券服务费</div>
        </div>
        <div class="item" v-if="hasData && orderInfo.discountAmount>0">
            <label>折扣</label>
            <span class="msg">-{{orderInfo.discountAmount}}元</span>
        </div>
        <div class="item">
            <label>总费用</label>
            <span class="msg">{{hasData ? orderInfo.totalAmount : ''}}元</span>
        </div>
        <div class="item" v-if="hasData && orderInfo.smsTemplateId != '-1'">
            <label>短信通知时显示的公司名</label>
            <span class="msg">{{hasData ? orderInfo.smsCompanyName : ''}}</span>
        </div>
    </div>
</template>
<script>
import CouponCard from 'Components/CouponCard.vue'
export default {
  name: 'CouponDetail',
  data () {
    return {
      hasData: Object.keys(this.couponInfo).length,
      orderInfo: Object.keys(this.couponInfo).length ? this.couponInfo.orderInfo : {}
    }
  },
  //   props: {
  //     couponInfo:  {}
  //   },
  props: ['couponInfo'],
  components: {CouponCard},
  watch: {
    couponInfo: function (value) {
      if (Object.keys(value).length) {
        this.hasData = true
        this.orderInfo = value.orderInfo
      }
    }
  }
}
</script>
<style lang="stylus">
    .coupondetail{
        .info-wrap{
            padding-left: 30px;
        }
        .couponinfo{
            margin-left: 58px;
        }
        .item{
            margin-top: 28px;
            margin-left: 27px;
            position: relative;
            label{
                width: 84px;
                display: inline-block;
                text-align: right;
                font-size:14px;
                color: #666;
                margin-right: 20px;
                position: absolute
            }
            .msg{
                margin-left: 103px;
                color: #333;
                font-size: 14px;
            }
            .msg_tip{
                font-size: 14px;
                color: #999;
            }
            .hintmsg{
                font-size: 14px;
                color: #999;
                margin-left: 100px;
                margin-bottom: -5px;
                margin-top: 2px;
            }
        }
    }

</style>
